import { render, staticRenderFns } from "./DnsManagementModal.vue?vue&type=template&id=66a8b84f&scoped=true"
import script from "./DnsManagementModal.vue?vue&type=script&lang=js"
export * from "./DnsManagementModal.vue?vue&type=script&lang=js"
import style0 from "./DnsManagementModal.vue?vue&type=style&index=0&id=66a8b84f&prod&scoped=true&lang=css"
import style1 from "./DnsManagementModal.vue?vue&type=style&index=1&id=66a8b84f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66a8b84f",
  null
  
)

export default component.exports